import {createIcon} from '@chakra-ui/react';

/** Bombo de marcha de banda (cilindro con aros y correas), distinto del bongo/djembe. */
export const IconoBomboMarcha = createIcon({
  displayName: 'IconoBomboMarcha',
  viewBox: '0 0 64 64',
  path: (
    <>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 9 L32 19 L44 9"
      />
      <ellipse cx="32" cy="24" rx="21" ry="7.5" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <ellipse cx="32" cy="40" rx="21" ry="7.5" fill="none" stroke="currentColor" strokeWidth="2.5" />
      <path fill="none" stroke="currentColor" strokeWidth="2.5" d="M11 24v16M53 24v16" />
      <ellipse cx="32" cy="32" rx="21" ry="7.5" fill="currentColor" opacity="0.18" />
      <ellipse cx="32" cy="24" rx="14" ry="4.5" fill="currentColor" opacity="0.28" />
    </>
  ),
});
